var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1748_591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9Z",
    fill: "#FF0000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1748_591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 7.26708 11.5989 8.50163 10.8541 9.52671C10.1093 10.5518 9.05916 11.3148 7.8541 11.7063C6.64904 12.0979 5.35096 12.0979 4.1459 11.7063C2.94084 11.3148 1.89067 10.5518 1.1459 9.52671L6 6H12Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12 6C12 5.05314 11.7759 4.11972 11.346 3.27606C10.9162 2.4324 10.2927 1.70245 9.52671 1.1459L6 6H12Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.52671 1.1459C8.76069 0.589347 7.87381 0.221993 6.93861 0.0738705C6.00341 -0.0742519 5.04642 0.00106371 4.1459 0.293659L6 6L9.52671 1.1459Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M4.1459 0.293661C3.24538 0.586257 2.42689 1.08783 1.75736 1.75736C1.08783 2.42689 0.58626 3.24537 0.293663 4.14589L6 6L4.1459 0.293661Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinner);
export default __webpack_public_path__ + "static/media/icon-spinner.7c0a7aab09d0e26dac6a3270f280f6fc.svg";
export { ForwardRef as ReactComponent };